import React, { useContext, useState } from "react"
import { Badge, Button, Card, CardBody, Col, Form, Input, Row, Spinner } from "reactstrap"

import LlmInstrContext from "./LlmInstrContext"

/**
 * Header strip: one input (QD Ref) plus the resolved context inline.
 *
 * A QD Ref is the only way in. Both pending_email_resp_appt and emailappt_resp_conf_detail
 * carry tenant_id AND m_loc_id next to mail_tracker, so a tracker resolves the location by
 * itself; a second, caller-supplied way to name a location would only add a mismatch to get
 * wrong, and tuning always starts from a reply someone is unhappy with anyway.
 */
function LocatorBar() {
  const { loading, resolved, resolveByTracker } = useContext(LlmInstrContext)

  const [tracker, setTracker] = useState("")

  const submit = e => {
    e.preventDefault()
    if (tracker.trim()) resolveByTracker(tracker.trim())
  }

  const loc = resolved?.response_context

  return (
    <Card className="mb-3">
      <CardBody>
        <Row className="align-items-center g-2">
          <Col md={5}>
            <Form onSubmit={submit}>
              <div className="d-flex align-items-center gap-2">
                <span className="text-muted small text-nowrap">QD Ref</span>
                <Input
                  bsSize="sm"
                  placeholder="paste a QD Ref from any reply…"
                  value={tracker}
                  onChange={e => setTracker(e.target.value)}
                  style={{ maxWidth: 220 }}
                />
                <Button color="primary" size="sm" type="submit" disabled={loading}>
                  {loading ? <Spinner size="sm" /> : "Load"}
                </Button>
              </div>
            </Form>
          </Col>

          <Col md={7}>
            {loc ? (
              <div className="bg-light border rounded p-2 small">
                <div className="d-flex flex-wrap align-items-center gap-2">
                  <Badge color="dark">{loc.tenant_shortname || loc.tenant_id}</Badge>
                  <span className="text-truncate">{loc.tenant_name}</span>
                  <span className="text-muted">│</span>
                  <strong>{loc.m_loc_id}</strong>
                  {loc.tenant_email && (
                    <>
                      <span className="text-muted">│</span>
                      <span className="text-muted">{loc.tenant_email}</span>
                    </>
                  )}
                </div>
                {loc.mail_tracker && (
                  <div className="text-muted mt-1">
                    reply {loc.mail_tracker}
                    {loc.response_rcvd_on ? ` · received ${loc.response_rcvd_on.replace("T", " ")}` : ""}
                    {loc.confirmation_strategy ? ` · ${loc.confirmation_strategy}` : ""}
                  </div>
                )}
              </div>
            ) : (
              <div className="text-muted small">
                Nothing loaded. Enter a QD Ref to see this facility&apos;s current instruction
                and its replies.
              </div>
            )}
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default LocatorBar
